import React from "react";
import { Modal, TextField } from "@shopify/polaris";
import { useAppContext } from "~/providers/app";

export const ModalConfig = () => {
  const sessionStorageConfig = sessionStorage.getItem("reactify-search:config");

  const { showModalConfig, setShowModalConfig } = useAppContext();
  const [config, setConfig] = React.useState<string>("");

  const setConfigSafe = (value: string) => {
    try {
      setConfig(JSON.stringify(JSON.parse(value), null, 2));
    } catch {
      setConfig(value);
    }
  };

  const handleActionSave = () => {
    try {
      sessionStorage.setItem("reactify-search:config", config);
    } catch (error) {
      console.error(error);
    }
  };

  React.useEffect(() => {
    if (sessionStorageConfig && sessionStorageConfig !== config) {
      setConfigSafe(sessionStorageConfig);
    }
  }, [sessionStorageConfig, config]);

  return (
    <Modal
      title="Configuration"
      open={showModalConfig}
      onClose={() => setShowModalConfig(false)}
      primaryAction={{
        content: "Save configuration",
        onAction: handleActionSave,
      }}
    >
      <Modal.Section>
        <TextField
          label="Config"
          autoComplete="no"
          type="text"
          value={config}
          onChange={(value) => setConfig(value)}
          multiline
        />
      </Modal.Section>
    </Modal>
  );
};
